import { GTM_CUSTOM_EVENT } from "../util/types";
import { GATSBY_FIREBASE_MEASUREMENT_ID } from "../util/variables";

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: any;
  }
}

export const triggerCustomEvent = (eventName: GTM_CUSTOM_EVENT) => {
  if (typeof window !== "undefined") {
    window.dataLayer?.push({ event: eventName });
  }
};

export const getClientId = async (): Promise<string | undefined> => {
  if (typeof window === "undefined") {
    console.log("window is undefined");
    return Promise.resolve(undefined);
  }

  if (!window.gtag) {
    console.log("gtag is undefined. gatsby-plugin-google-gtag only works in production.");
    return Promise.resolve(undefined);
  }

  return new Promise(resolve => {
    window.gtag("get", GATSBY_FIREBASE_MEASUREMENT_ID, "client_id", (clientID: string) => {
      console.log("clientID", clientID);
      resolve(clientID);
    });
  });
};
